import { createBrowserRouter, RouterProvider } from 'react-router-dom';

//~ Import your paths here
import {
    AccountsSelectionPagePath,
    AdvancedSearchPagePath,
    AssetDetailsPagePath,
    CollectionDetailsPagePath,
    DetailsPath,
    ExtendedCollectionsPagePath,
    HomePagePath,
    LoginPagePath,
    NotFoundPagePath,
    OperationsPagePath,
    ProductionsSelectionPagePath,
} from '../constants/Paths';

//~ Import your layouts here
import { AppLayout } from '@common/layouts/App';

//~ Import your Page components here
import { ProtectionLevel } from '../types/ProtectionLevels';
import { MainAppWrapper } from './MainAppWrapper';
import { PermissionGate } from './PermissionGate';

import { AccountSelectionPage } from '@features/accounts/pages/AccountSelectionPage';
import { AdvancedSearchPage } from '@features/advancedSearch';
import { LoginPage } from '@features/authentication';
import { AssetDetailsPage } from '@features/Clip/pages';
import { CollectionDetailsPage } from '@features/Collection';
import { ProductionSelectionPage } from '@features/productions';
import { HomePage, NotFoundPage } from '@pages';
import { ExtendedCollectionsPage } from '@pages/ExtendedCollections';
import { OperationPage } from '@pages/Operations';

const router = createBrowserRouter([
    {
        path: '/',
        element: <AppLayout />,
        children: [
            {
                path: LoginPagePath,
                element: (
                    <PermissionGate
                        requiredProtectionLevel={ProtectionLevel.NONE}
                    >
                        <LoginPage />
                    </PermissionGate>
                ),
            },
            {
                path: '/',
                element: (
                    <PermissionGate
                        requiredProtectionLevel={ProtectionLevel.AUTHENTICATED}
                    >
                        <MainAppWrapper />
                    </PermissionGate>
                ),
                children: [
                    {
                        path: AccountsSelectionPagePath,
                        element: <AccountSelectionPage />,
                    },
                    {
                        path: ProductionsSelectionPagePath,
                        element: (
                            <PermissionGate
                                requiredProtectionLevel={
                                    ProtectionLevel.AUTHENTICATED |
                                    ProtectionLevel.ACCOUNT_SELECTED
                                }
                            >
                                <ProductionSelectionPage />
                            </PermissionGate>
                        ),
                    },
                    {
                        path: HomePagePath,
                        element: (
                            <PermissionGate
                                requiredProtectionLevel={
                                    ProtectionLevel.AUTHENTICATED |
                                    ProtectionLevel.ACCOUNT_SELECTED |
                                    ProtectionLevel.PRODUCTION_SELECTED
                                }
                            >
                                <HomePage />
                            </PermissionGate>
                        ),
                    },
                    {
                        path: OperationsPagePath,
                        element: (
                            <PermissionGate
                                requiredProtectionLevel={
                                    ProtectionLevel.AUTHENTICATED |
                                    ProtectionLevel.ACCOUNT_SELECTED |
                                    ProtectionLevel.PRODUCTION_SELECTED
                                }
                            >
                                <OperationPage />
                            </PermissionGate>
                        ),
                    },
                    {
                        path: ExtendedCollectionsPagePath,
                        element: <ExtendedCollectionsPage />,
                    },
                    {
                        path: DetailsPath,
                        // handle: { hideGlobalParticles: true },
                        children: [
                            {
                                path: CollectionDetailsPagePath,
                                element: <CollectionDetailsPage />,
                            },
                            {
                                path: AssetDetailsPagePath,
                                element: <AssetDetailsPage />,
                            },
                        ],
                    },
                    {
                        path: AdvancedSearchPagePath,
                        element: (
                            <PermissionGate
                                requiredProtectionLevel={
                                    ProtectionLevel.AUTHENTICATED |
                                    ProtectionLevel.ACCOUNT_SELECTED |
                                    ProtectionLevel.PRODUCTION_SELECTED
                                }
                            >
                                <AdvancedSearchPage />
                            </PermissionGate>
                        ),
                    },
                ],
            },

            {
                path: NotFoundPagePath,
                element: <NotFoundPage />,
            },
        ],
    },
]);

export const AppRouter = () => {
    return <RouterProvider router={router} />;
};
